import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Edit, IdCard, ListCheck, CalendarDays, Gift } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import ShimmerLoader from '../../hooks/ShimmerLoader';
import formatDate from '../../hooks/formatDate';
import Pagination from "../../hooks/Pagination";
import { useAuth } from "../../context/AuthContext";
import { fetchEarningByCustomer } from "../../store/loyaltySlices/loyaltyReportsSlice";

import toastr from 'toastr';

import { format } from 'date-fns';
import FilterBox from "./FilterBox";

export default function Earningbycustomer() {
  const { user } = useAuth();
  useDocumentTitle('Welcome to Admin | Loyalty Card');
  const dispatch = useDispatch();
  const { items: loyalty_card, loading, error, totalPages } = useSelector((state) => state.loyaltyReports.earning);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalOrderAmount, settotalOrderAmount] = useState(0);
  const [totalRewardEarn, settotalRewardEarn] = useState(0);
  const [filters, setFilters] = useState(undefined);

  const perPage = 100;
  useEffect(() => {
    dispatch(fetchEarningByCustomer({ perPage, page: currentPage, filters }));
  }, [currentPage, filters, dispatch]);

  // Derive the summary totals whenever the fetched list changes
  // useEffect(() => {
  //   if (loyalty_card.length > 0) {
  //     const orderTotal = loyalty_card.reduce((sum, reward) => sum + reward.order_amount, 0);
  //     const rewardTotal = loyalty_card.reduce((sum, reward) => sum + reward.rewardearn, 0);
  //     settotalOrderAmount(orderTotal);
  //     settotalRewardEarn(rewardTotal);
  //   } else {
  //     settotalOrderAmount(0);
  //     settotalRewardEarn(0);
  //   }
  // }, [loyalty_card]);
  useEffect(() => {
    if (loyalty_card.length > 0) {
        const orderTotal = loyalty_card.reduce(
            (sum, reward) => sum + Number(reward.order_amount || 0),
            0
        );

        const rewardTotal = loyalty_card.reduce(
            (sum, reward) => sum + Number(reward.rewardearn || 0),
            0
        );

        settotalOrderAmount(orderTotal);
        settotalRewardEarn(rewardTotal);
    } else {
        settotalOrderAmount(0);
        settotalRewardEarn(0);
    }
}, [loyalty_card]);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  // };

  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setIsActive(!isActive);
  };

  const handleFilterApply = (newFilters) => {
    setFilters(newFilters);
    // console.log('Applied filters:', newFilters);
    // Here you would typically filter your data or make an API call
  };

  return (
    <>

      <div className="flex flex-col md:flex-row gap-4 md:gap-4">
        {error && <div style={{ color: 'red' }}>{error}</div>}
        <div className="w-full  bg-white shadow-lg rounded-2xl p-6">

          <div className="grid grid-flow-col grid-rows-3 gap-4">
            <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Earning By Customer</h2></div>

            <div className="row-start-1 row-end-4 text-right">
              <button type="button" onClick={handleClick} className="py-2 px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors">{isActive ? 'Close' : 'Filter'}</button>
            </div>
          </div>
          {isActive && (
            <FilterBox onFilterApply={handleFilterApply} />
          )}

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4 mb-4">
            <div className="p-4 bg-white rounded-xl shadow ring-2 flex flex-col items-center hover:shadow-md transition">
              <div className="text-blue-900 text-2xl">{totalOrderAmount.toFixed(2)}</div>
              <p className="mt-2 text-sm font-medium text-gray-700 text-center">
                Total Order Value
              </p>
            </div>
            <div className="p-4 bg-white rounded-xl shadow ring-2 flex flex-col items-center hover:shadow-md transition">
              <div className="text-blue-900 text-2xl">{totalRewardEarn.toFixed(2)}</div>
              <p className="mt-2 text-sm font-medium text-gray-700 text-center">
                Total Reward Earn
              </p>
            </div>
          </div>

          <div className="overflow-auto">



            <table className="w-full text-sm text-left">
              <thead className="text-gray-700 bg-gray-100">
                <tr>
                  <th className="p-3">Customer Name </th>
                  <th className="p-3">Reward Name</th>
                  <th className="p-3 text-right">Order Value</th>
                  <th className="p-3 text-right">Reward Earn </th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {loading ? (
                  <>
                    <tr>
                      <td className="p-3" colSpan={4}>
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    {!loading && loyalty_card.length > 0 ? (
                      loyalty_card.map((item) => (
                        <tr key={item.id}>
                          <td className="p-3">{item.name}</td>
                          <td className="p-3">{item.reward_name}</td>
                          <td className="p-3 text-right">{Number(item?.order_amount || 0).toFixed(2)}</td>
                          <td className="p-3 text-right">{Number(item?.rewardearn || 0).toFixed(2)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="p-3" colSpan={7}>
                          No record found
                        </td>
                      </tr>
                    )}

                  </>
                )}

              </tbody>
            </table>
            <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
        </div>
      </div>

    </>
  );
}
